/** The shared "Batch edit…" grid action. Add to a grid's `batchActions` once the
 *  backend declares the `batch_edit` op for its resource (and the resource has a
 *  batch-edit catalog entry).
 *
 *  Gated on `console_batch_edit` — the mass-mutation permission — rather than
 *  the grid's manage permission; the backend checks both at dispatch.
 */
import EditNoteIcon from '@mui/icons-material/EditNote';

import type { BatchActionDef } from '@/components/DataGrid/batchTypes';

import { BatchEditDialog } from './BatchEditDialog';

export function batchEditAction(resource: string, noun: string): BatchActionDef {
  return {
    key: 'batch_edit',
    label: 'Batch edit…',
    icon: <EditNoteIcon fontSize="small" />,
    permission: 'console_batch_edit',
    dialog: (ctx) => <BatchEditDialog ctx={ctx} resource={resource} noun={noun} />,
  };
}
